export function write(key: string, value: string, maxAge = 3600): void {
  document.cookie = `${key}=${value};max-age=${maxAge};samesite=strict`
}

export function read(key: string): string | null {
  const rowFound = document.cookie
    .split('; ')
    .find((row: string) => row.startsWith(`${key}=`))
  if (rowFound) {
    return rowFound.split('=')[1]
  }
  return null
}

export function clear(key: string): void {
  write(key, '', 0)
}
